/**
 * Array contendo as opções de menu de relatórios a serem disponibilizados
 */
export const menuRelatorios = [
    {
        groupLabel: "Relatórios Financeiros",
        groupKey: "relatoriosFinanceiros",
        menus: [
            {
                label: "Comparativo de Custo Planejado vs Real",
                path: "realPlanejadoCusto",
                info: "Exibe uma tabela acompanhada de um gráfico que compara o custo planejado na venda do projeto com o custo real ao longo do tempo."
            },
            {
                label: "Histórico de Custo por Cliente / Projeto",
                path: "historicoCustoClienteProjeto",
                info: "Exibe o histórico dos custos associados a cada cliente e projeto."
            },
            {
                label: "Comparativo de Faturamento Planejado vs Real",
                path: "realPlanejadoFaturamento",
                info: "Apresenta uma tabela e um gráfico que comparam o faturamento previsto na venda com o faturamento real do projeto ao longo do tempo."
            },
            {
                label: "Resultado do Projeto",
                path: "resultadoAnualProjeto",
                info: "Fornece uma visão da saúde financeira do projeto considerando o faturamento, o custo e a margem."
            },
            {
                label: "Fluxo de Caixa de Projetos",
                path: "fluxoDeCaixaDeProjetos",
                info: "Apresenta uma comparação entre o fluxo de caixa previsto na venda e o realizado ao longo de um período."
            },
            {
                label: "Resultados de Cliente/Líder",
                path: "resultadosDoCliente",
                info: "Fornece uma visão da saúde financeira da conta ou dos projetos do líder, considerando o faturamento, o custo e a margem."
            }
        ]
    },
    {
        groupLabel: "Relatórios de Planejamento",
        groupKey: "relatoriosPlanejamento",
        menus: [
            {
                label: "Capacidade da Área",
                path: "relatorioCapacidade",
                info: "Taxa de Capacidade da Área"
            },
            {
                label: "Capacidade por Projeto",
                path: "capacidadeProjeto",
                info: "Taxa de Capacidade da Área por Projeto"
            },
            {
                label: "Relatório de Turnover",
                path: "relatorioTurnover",
                info: "Histórico de turnover, dos colaboradores CLT do Delivery e Engesol."
            },
            {
                label: "Relatório Histórico Capacidade",
                path: "relatorioHistoricoCapacidade",
                info: "Histórico de capacidade, dos colaboradores CLT do Delivery e Engesol."
            },
            {
                label: "Relatório Comparativo Ponto vs Jira",
                path: "comparativoPontoJira",
                info: "Exibe uma tabela com todos os colaboradores do Delivery e Engesol, com o comparativo das horas lançadas no sistema de Ponto e no Jira."
            },
            {
                label: "Relatório de Horas no Ponto",
                path: "relatorioRelacaoHoras",
                info: "Exibe uma tabela com as horas registradas no Ponto por todos os colaboradores do Delivery e Engesol."
            },
            {
                label: "Relatório Histórico de Horas Extras",
                path: "relatorioHistoricoHorasExtras",
                info: "Exibe uma tabela com o histórico de horas extras registradas por todos os colaboradores do Delivery e Engesol."
            },
            {
                label: "Histórico de Banco de Horas",
                path: "relatorioBancoDeHoras",
                info: "Exibe o saldo do banco de horas (Balanço) dos colaboradores do Delivery e Engesol por período."
            }
        ]
    }
];

/**
 * Filtra o menu de relatórios conforme o termo recebido
 * @param {string} termo a ser buscado no array de menu
 * @returns {Array<any>} array de opções filtrado pelo termo
 */
export const applyFiltroMenu = (termo = "") => {
    if (!termo.length) return menuRelatorios;
    
    const filtrados = [];
    const lowerTermo = termo.toLowerCase();

    menuRelatorios.forEach((group => {
        const menus = group.menus.filter(item => {
            const lowerLabel = item.label.toLowerCase();
            return lowerLabel.includes(lowerTermo);
        })

        if (menus.length) {
            filtrados.push({...group, menus});
        }
    }));

    return filtrados;
} 
